import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const BoutiquePage = lazy(() => import('../pages/boutique/page'));
const ProductPage = lazy(() => import('../pages/produit/page'));
const SoinsEsthetiquesPage = lazy(() => import('../pages/soins-esthetiques/page'));
const PlasmaMonslanding = lazy(() => import('../pages/landing/plasma-mons/page'));
const ConversionLanding = lazy(() => import('../pages/landing/conversion-landing/page'));
const MentionsLegalesPage = lazy(() => import('../pages/mentions-legales/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/boutique',
    element: <BoutiquePage />,
  },
  {
    path: '/produit',
    element: <ProductPage />,
  },
  {
    path: '/soins-esthetiques',
    element: <SoinsEsthetiquesPage />,
  },
  {
    path: '/plasma-mons',
    element: <PlasmaMonslanding />,
  },
  {
    path: '/offre-speciale',
    element: <ConversionLanding />,
  },
  {
    path: '/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
